import React from "react";
import ReactDOM from "react-dom/client";
import "styles/index.scss";
import "styles/output.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("gsiMap") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
